export default {
    config: {
        defaultWidth: 60
    },
    default: {
        label: 'Age (com.)'
    },
    unique: [],
    sort: 'age.community',
    lang: {
        name: 'Community Age',
        category: 'Game',
        description: 'Community-voted minimum age.',
        views: ['list', 'sheet'],
    },
    filters: ['age.community']
}
